	<template>
	<div class="pageBox">
		<div class="exDetail">
		    <header>
		        <h1><span><b>{{data.caption}}</b></span></h1>
		    </header>
		    <div class="exBanner">
		        <img :src="data.cover" alt="">
		    </div>
		    <div class="audio" v-show="data.source!==''">
		       <div class="so_rs">
		           <div class="audio-btn">
		                <i @click="audioState"><img :src="imgUrl2" alt="" v-show="iconshouw==true ? true : false"><img :src="imgUrl1" alt=""  v-show="iconshouw==true?false : true"/></i>
		           </div>
		           <div class="bar" style="position: relative;">
		               <div class="progressbar"  ref="runfatbar" @click="playMusic">
		                   <div class="greenbar" ref="runbar">
		                       <span class="yuan" draggable="true"></span>
		                   </div>
		               </div>
		               <span style="margin-top:-3px;position: absolute;right: 0;font-size: 10px;color: #999;">{{cTime}}</span>
		               <span style="margin-top:-3px;position: absolute;left:-5px;font-size: 10px;color: #999;">{{dTime}}</span>
		           </div>
		           <div>
		               <audio ref="player" :src="data.source">
		               </audio>
		           </div>
		       </div>
		    </div>
		    <div class="exInfo" v-html="data.content">
		        
		    </div>
		    <div class="advPano"><a :href="data.panorama"><img src="../static/imgs/advPano.png" alt=""></a></div>
		</div>
		<div class="exPro">
		    <h2 class="tit">展览作品</h2>
		    <div ref="wrapper" class="wrapper">
		    	<ul class="fix" style="display:flow-root"> 
		    	    <li v-for="item in listdata">
		    	        <router-link tag="a" :to="{path:'proDetail',query:{id:item.Id}}">
		    	            <div class="img"><img :src="item.Pic" alt=""></div>
		    	            <div class="txt">
		    	                <h3>《{{item.Name}}》</h3>
		    	                <p>{{item.Author}}</p>
		    	            </div>
		    	        </router-link>
		    	    </li>
		    	</ul>
		    </div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import BScroll from 'better-scroll'
	export default {
		data(){
			return{
				data:'',
				id:'',
				listdata:[],
				page:0,
				iconshouw:true,
				play: false, // 播放暂停按钮
				imgUrl1:require('../static/imgs/stop.png'),
				imgUrl2:require('../static/imgs/btn_90-90.png'),
				cTime: '00:00', // 已播放时间
				dTime: '00:00', // 总播放时间
				play: false, // 播放暂停按钮
				audioHttp: '', // 音频链接
				barOffleft: '', //点击距离左侧时间
			}
		},
		created(){
			const that = this;
			this.$nextTick(() => {
			  	this.scroll = new BScroll(this.$refs.wrapper,{       
			  		//初始化better-scroll
			        probeType:1,   //1 滚动的时候会派发scroll事件，会截流。2滚动的时候实时派发scroll事件，不会截流。 3除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
			        click: true,   //是否派发click事件
			        useTransition:false,  // 防止iphone微信滑动卡顿
			   	}) 
			   	// 滑动过程中事件
			   	this.scroll.on('scroll',(pos)=>{
			   	    if(pos.y<(this.scroll.maxScrollY - 30)){
			   	        //console.log(pos.y)
			   	    }
			   	});  
			   	//滑动结束松开事件
			   	 this.scroll.on('touchEnd',(pos) =>{  //上拉刷新
			   	     if(pos.y<(this.scroll.maxScrollY - 30)){
			   	       this.page++;
			   	       this.getList()
			   	     } 
			   	 })                                  
			})
		},
		mounted(){
			this.id=this.$route.query.id;
			this.getData()
			this.getList()
			//音频播放处理
			const music = this.$refs.player  // 音频所在对象
			const musicBar = this.$refs.runbar  // 颜色进度条所在对象
			const musicWidth = this.$refs.runfatbar.offsetWidth // 底部进度条总宽
			// 获得音频加载完成可播放时的处理
			music.addEventListener('canplay', (res) => {
			    const musicTime = music.duration // 获得音频时长
			    //console.log(res)
			    const branch = Math.floor(musicTime / 60) // 计算音频分钟
			    const second = Math.ceil(musicTime % 60) // 计算音频秒
			    if (branch < 10 && second < 10) { // 四种情况判断音频总时间
			        this.dTime = `0${branch}:0${second}`
			    } else if (branch < 10) {
			        this.dTime = `0${branch}:${second}`
			    } else if (second < 10) {
			        this.dTime = `${branch}:0${second}`
			    } else {
			        this.dTime = `${branch}:${second}`
			    }
			})

			// 获得音频正在播放时的处理
			music.addEventListener('timeupdate', () => {
			    const musicTime = music.duration // 获得音频时长
			    const stopTime = music.currentTime // 获得已播放的音频时长
			    musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
			    const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
			    const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
			    if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
			        this.cTime = `0${branch}:0${second}`
			    } else if (branch < 10) {
			        this.cTime = `0${branch}:${second}`
			    } else if (second < 10) {
			        this.cTime = `${branch}:0${second}`
			    } else {
			        this.cTime = `${branch}:${second}`
			    }
			})
			musicBar.addEventListener('touchmove', (event) => {
			     const events = event.targetTouches[0].pageX-this.$refs.runfatbar.offsetLeft // 获得触摸拖动的距离
			     if(events <= musicWidth){
			         musicBar.style.width = `${(events / musicWidth) * 100}%` // 计算进度条所在比例宽度
			     }else{
			         musicBar.style.width = '100%'
			     }
			     music.pause() // 触摸拖动时停止播放
			})
			 // 监听颜色进度条是否触摸拖动结束
			 musicBar.addEventListener('touchend', () => {
			     const touwidth = (musicBar.offsetWidth / musicWidth) // 计算进度条所在比例
			     //console.log(touwidth)
			     music.currentTime = music.duration * touwidth // 通过所在比例赋值给音频应在的播放时间
			     music.play() // 根据播放时间开始播放
			     this.play = true // 更改播放暂停按钮为播放
			})
		},
		methods:{
			getData(){
				this.$http.get(this.$api+'/exhibit_detail_api.html?id='+this.id)
				.then(res => {
					this.data=res.data.data;
					console.log(this.data,789)
				})
			},
			getList(){
				this.$http.get(this.$api+'/exhibit_work_api.html?id='+this.id+'&page='+this.page)
				.then(res => {
					this.listdata=this.listdata.concat(res.data.data);
				  	//console.log(this.listdata,123)
				})
			},
			//点击播放暂停按钮时间
			audioState () {
			   this.iconshouw=!this.iconshouw;
			    this.play = !this.play;// 更改播放暂停按钮状态
			    const music = this.$refs.player // 音频所在对象
			    if (this.play) {
			        music.play() // 播放音乐
			    } else {
			        music.pause() // 暂停音乐
			    }
			},
			//点击进度条事件
			playMusic (e) {
			    const music = this.$refs.player // 音频所在对象
			    const barWidth = (e.pageX-this.$refs.runfatbar.offsetLeft)/ this.$refs.runfatbar.offsetWidth // 计算点击位置相对父元素总宽的比例
			    this.$refs.runbar.style.width = `${barWidth * 100}%` // 进度条应所在的比例总宽
			    music.currentTime = music.duration * barWidth // 计算点击时应播放所在的时间
			    music.play() // 播放音频
			    this.play = true // 更改播放暂停按钮为播放
			},
		}
	}
</script>
<style scoped>
	.exDetail{background-color: #fff;padding-bottom: 1.05rem;}
	.exBanner{width:16.5rem;margin:0 auto;margin-bottom:1rem;}
	.exBanner img{width: 100%}
	header{text-align: center;}
	h1{font-size: .8rem;font-weight: bold;max-width:10.65rem;margin:0 auto;text-align: center;position: relative;display:inline-block;padding:1rem 0;}
	h1 span:before, h1 span:after{content:"";position: absolute;height:2px;background-color: #AD4916;width:1.75rem;top:50%;margin-top: -1px;display:block;}
	h1 span:before{left:-2.925rem;}
	h1 span:after{right:-2.925rem;}
	h1 b:before,h1 b:after{content:"";position: absolute;height:.2rem;width:.2rem;display: block;transform:rotate(45deg);top:50%;margin-top: -.1rem;background-color: #AD4916;}
	h1 b:before{left:-.8rem;}
	h1 b:after{right:-.8rem;}
	.exInfo{padding:0 1.5rem 1.5rem;line-height: 1.2rem;color:#666;font-size: .7rem;padding-bottom: 0}
	.exInfo >>>p{text-align:justify;}
	.exInfo >>>p img{width: 100%!important;height:100%!important;}
	.advPano{width:11.05rem;height:2.5rem;margin:0 auto;margin-top:1rem;}
	.advPano img{width:100%}
	.exPro{padding-left: .5rem;background-color: #fff;border-top: .25rem solid #f3f3f3;}
	.exPro a{display:block;}
	.exPro .tit{font-size: .75rem;color:#333;padding:1rem 0 .65rem .65rem;}
	.exPro li{width:4.25rem;float:left;margin-right: .25rem;height:7.4rem;text-align: center;}
	.exPro .img{display:-webkit-box;width:4.25rem;height:4.25rem;overflow: hidden;-webkit-box-orient:horizontal;-webkit-box-pack:center;-webkit-box-align:center;background-color: #eee;}
	.exPro .img img{width: 100%}
	.exPro .txt h3{font-size: .7rem;color:#999;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding-top: .15rem;margin-top: .3rem;margin-bottom: .4rem;}
	.exPro .txt p{font-size: .55rem;color:#999;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
	.wrapper{width: 100%;height:400px;overflow: hidden;position: relative;}

	.so_rs{
	    width: 100%;
	    height:2.75rem;
	    background: #f9f9f9;
	    position:relative;
	    box-sizing: border-box;
	    display: flex;
	    padding-top:.5rem;
	    margin-bottom:1rem;
	}
	/*自定义进度条*/
	.bar{
	    width: 60%;
	    height:1.4rem;
	    line-height:1.4rem;
	    box-sizing: border-box;
	    padding:.75rem 0;
	}
	/*播放按钮*/
	.audio-btn{
	    width: 32px;
	    left: 1.14rem;
	    margin:0 20px;
	    margin-left: 2.5rem;
	}
	.audio-btn i img{
		width: 100%;
	}
	.icon{
	    display:block;
	    height:1.3rem;
	    width:1.3rem;
	}
	.progressbar{
	    width:100%;
	    height: .1rem;
	    background-color: #999999;
	    border-radius: 10px;
	    position: relative;
	    font-size:0;
	}
	.greenbar {
	    width: 0%;
	    height: .1rem;
	    border-radius: .2rem;
	    position: absolute;
	    top: 0;
	    left: 0;
	    background-color: #e77959;
	}
	.yuan {
	    display: inline-block !important;
	    padding: .15rem;
	    background-color: #e77959;
	    box-sizing: border-box;
	    border-radius: 50%;
	    position: absolute;
	    top: -.09rem;
	    right: -.1rem;
	}
</style>